define([
    'angular',
    './controllers/leads',
    './services/leads',
    '../site/services/announcement',
    '../site/services/site',
    'angular-ui-router',
    '../user/services/profile',
    'angular-utils-pagination',
    '../services/fileUpload',
    'ng-file-upload',
], function (angular, leadsCtrl) {
    'use strict';

    var app = angular
        .module('leadApp', [
            'announcementServices',
            'leadServices',
            'profileServices',
            'ui.router',
            'angularUtils.directives.dirPagination',
            'siteServices',
            'ngFileUpload',
            'fileUploadService',
        ])
        // controllers
        .controller(leadsCtrl.name, leadsCtrl.arguments)
        // routes
        .config([
            '$stateProvider',
            '$locationProvider',
            'paginationTemplateProvider',
            function ($stateProvider, $location, paginationTemplateProvider) {
                $location.html5Mode({
                    enabled: true,
                    requireBase: false,
                });
                $stateProvider
                    .state('leads', {
                        abstract: true,
                    })
                    .state('leads.list', {
                        url: Routing.generate('leads') + '?f&c',
                        title: 'Leads',
                        views: {
                            'body@': {
                                controller: 'leadsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppLead',
                                        entity: 'Lead',
                                        template: 'partials/list.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('leads.create', {
                        url: decodeURIComponent(
                            Routing.generate('create_lead', { _format: 'html' })
                        ),
                        title: 'Create Lead',
                        views: {
                            'body@': {
                                controller: 'leadsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppLead',
                                        entity: 'Lead',
                                        template: 'partials/edit.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('leads.settings', {
                        url: Routing.generate('lead_settings', {
                            _format: 'html',
                        }),
                        title: 'Lead Settings',
                        views: {
                            'body@': {
                                controller: 'editProfileCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppLead',
                                        entity: 'Lead',
                                        template: 'partials/settings.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('leads.update', {
                        url: decodeURIComponent(
                            Routing.generate('update_lead', {
                                _format: 'html',
                                lead: ':lead',
                            })
                        ),
                        title: 'Update Lead',
                        views: {
                            'body@': {
                                controller: 'leadsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppLead',
                                        entity: 'Lead',
                                        template: 'partials/edit.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('leads.view', {
                        url: decodeURIComponent(
                            Routing.generate('view_lead', {
                                _format: 'html',
                                lead: ':lead',
                            })
                        ),
                        title: 'View Lead',
                        views: {
                            'body@': {
                                controller: 'leadsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppLead',
                                        entity: 'Lead',
                                        template: 'partials/view.html',
                                    }
                                ),
                            },
                        },
                    });
                paginationTemplateProvider.setPath(
                    Routing.generate('angular_partial', {
                        bundle: 'AppLead',
                        entity: 'Lead',
                        template: 'partials/dirPagination.html',
                    })
                );
            },
        ]);
    return app;
});
